"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Canvas = void 0;
var Canvas = /** @class */ (function () {
    function Canvas() {
        this.doRemoveAnimationList = [];
        // tslint:disable-next-line: variable-name
        var _this = this;
        // tslint:disable: only-arrow-functions
        this.requestAnimationFrame = window.requestAnimationFrame ||
            window["webkitRequestAnimationFrame"] ||
            window["mozRequestAnimationFrame"] ||
            function (callback) {
                var currTime = new Date().getTime();
                var timeToCall = Math.max(0, 16.7 - (currTime - _this.lastTime));
                var id = window.setTimeout(function () {
                    callback(currTime + timeToCall);
                }, timeToCall);
                _this.lastTime = currTime + timeToCall;
                return id;
            };
        this.cancelAnimationFrame = window.cancelAnimationFrame ||
            window["webkitCancelAnimationFrame"] ||
            window["mozCancelAnimationFrame"] ||
            function (id) {
                clearTimeout(id);
            };
        // tslint:enable: only-arrow-functions
    }
    Canvas.prototype.startAnimation = function (callBack, targetObj) {
        var self = this;
        // tslint:disable-next-line: only-arrow-functions
        return (function (fn, obj) {
            var handler;
            // tslint:disable-next-line: only-arrow-functions
            var animation = function () {
                var mIndex = self.doRemoveAnimationList.indexOf(handler);
                if (mIndex < 0) {
                    fn.apply(obj, arguments);
                    return self.requestAnimationFrame.call(window, animation);
                }
                else {
                    self.doRemoveAnimationList.splice(mIndex, 1);
                }
                mIndex = null;
            };
            handler = self.requestAnimationFrame.call(window, animation);
            return handler;
        })(callBack, targetObj);
    };
    Canvas.prototype.stopAnimation = function (handler) {
        this.cancelAnimationFrame.call(window, handler);
        this.doRemoveAnimationList.push(handler);
    };
    return Canvas;
}());
exports.Canvas = Canvas;
